import { css } from 'styled-components';
import { StyledImg } from '../../../../components/LazyImg/styles';

export default css`
  &${StyledImg} {
    border-radius: 0;
  }
`;
